import { render, staticRenderFns } from "./single-upload.vue?vue&type=template&id=4c6a9d79&scoped=true&"
import script from "./single-upload.vue?vue&type=script&lang=js&"
export * from "./single-upload.vue?vue&type=script&lang=js&"
import style0 from "./single-upload.vue?vue&type=style&index=0&id=4c6a9d79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6a9d79",
  null
  
)

export default component.exports